export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#37ABB8';
  const bg = props?.bgColor ?? 'white';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="10.2458" cy="10" rx="9.75457" ry="9.75457" fill={bg} />
      <path
        d="M13.6263 9.60575C13.9359 9.78111 13.9359 10.2195 13.6263 10.3949L8.05222 13.5514C7.74256 13.7268 7.35547 13.5076 7.35547 13.1568L7.35547 6.8438C7.35547 6.49307 7.74256 6.27387 8.05222 6.44923L13.6263 9.60575Z"
        fill={c}
      />
    </svg>
  );
}
